"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConvertDataValue = void 0;
const createConvertDataValue = (createConvertDataArray, createConvertDataObject, isDataArray, isDataObject) => {
  const convertDataValue = value => {
    if (value === null) {
      return {
        NULL: true
      };
    }
    if (typeof value === 'boolean') {
      return {
        BOOL: value
      };
    }
    if (typeof value === 'number') {
      return {
        N: value.toString()
      };
    }
    if (typeof value === 'string') {
      return {
        S: value
      };
    }
    if (isDataArray(value)) {
      return {
        L: convertDataArray(value)
      };
    }
    if (isDataObject(value)) {
      return {
        M: convertDataObject(value)
      };
    }
    throw new Error('Unsupported data type');
  };
  const convertDataArray = createConvertDataArray(convertDataValue);
  const convertDataObject = createConvertDataObject(convertDataValue);
  return convertDataValue;
};
exports.createConvertDataValue = createConvertDataValue;